import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { IState } from "@/store";
import { IRegion } from "@/models/constants";

@Component({
  computed: {
    ...mapState({
      regions: (state: IState) => state.constants.regions
    })
  }
})
export default class RegionsStore extends Vue {
  public regions!: IRegion[];

  public regionsStoreLoadData({ countryId, countryCode }) {
    return this.$store.dispatch("constants/getRegions", {
      countryId,
      countryCode
    });
  }

  public getRegionPropValue(regionId: IRegion["id"], propValue: string) {
    return this.$_.get(
      this.$_.find(this.regions, ["id", regionId]),
      propValue,
      ""
    );
  }
}
